import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Divider, FontIcon, RaisedButton } from 'material-ui';
import { FormattedMessage } from 'react-intl';
import styles from 'styles/TBenefits';
import { get, groupBy, map } from 'lodash';
import moment from 'moment';

import KFlatButton from 'components/KJRN/KFlatButton';
import TLoading from './TLoading';
import TMessage from './TMessage';
import { fetchOpenEntry, initialize } from '../../sites/time/actions';
import ExpectedHours from '../../sites/time/components/ExpectedHours';
import EntryModal from '../../sites/time/components/EntryModal';

const TTimeEntries = ({ valuesByKey }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const closeModal = () => setModalOpen(false);
  const openModal = () => setModalOpen(true);
  const dispatch = useDispatch();
  const {
    openEntryFetching, openEntryFetched, openEntryError, openEntryErrorMessage,
    isPunching, initializeFailed, initializing, hasError, error, entries,
  } = useSelector(state => state.timeReducer);
  const entriesByDate = groupBy(map(entries, entry => ({ ...entry, date: moment(entry.ClockIn).format('DD/MM/YY') })), 'date');

  useEffect(() => {
    dispatch(fetchOpenEntry());
    dispatch(initialize());
  }, []);

  if (openEntryFetching || (!openEntryFetched && !openEntryError) || initializing) {
    return <TLoading />;
  }
  if (openEntryError || hasError || initializeFailed) {
    return <TMessage type="error" message="tile.error" values={{ error: openEntryErrorMessage || error }} />;
  }

  return (
    <div style={styles.container} data-cy="entries">
      <EntryModal
        modalState={modalOpen}
        closeModal={closeModal}
        selectedEntries={[]}
        entriesByDate={entriesByDate}
      />
      <div style={{
            maxHeight: 422, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center',
          }}
      >
        {get(valuesByKey, ['Hide.TimeEntries.ExpectedHours', 'Value']) !== 'true' ? <ExpectedHours /> : null}
        <div style={{
              flex: 1, flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
        >
          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <RaisedButton primary style={{ marginBottom: 24 }} icon={<FontIcon className="material-icons">alarm_on</FontIcon>} label={<FormattedMessage id="time.CreateEntry" />} onClick={openModal} disabled={isPunching} />
          </div>
        </div>
      </div>
      <Divider style={{ marginTop: 'auto' }} />
      <KFlatButton
        data-cy="time-button"
        style={styles.actionButton}
        onClick={() => dispatch(push('/time'))}
        containerStyle={styles.action}
        label={<FormattedMessage id="tile.time.goto" />}
      />
    </div>
  );
};
TTimeEntries.propTypes = {
  valuesByKey: PropTypes.object,
};

export default connect(state => ({ valuesByKey: state.WebValuesReducer.valuesByKey }))(TTimeEntries);



// WEBPACK FOOTER //
// ./src/containers/tiles/TTimeEntries.js